export const uniqArray = (a: []) => {
    return Array.from(new Set(a));
}